import {
  clientViewPartnerPortalBase,
  clientViewPartnerPortalPath,
} from "./clientViewPartnerPortalRoutes.js";
import { automapAdminPortalPath, AUTOMAP_ADMIN_PORTAL_BASE } from "./automapAdminPortalPaths.js";

export const AUTOMAP_CLIENT_VIEW_SLUG = "automap";

/** @deprecated Use AUTOMAP_ADMIN_PORTAL_BASE — AutoMapa ops console moved to /v/automap/admin */
export const AUTOMAP_PARTNER_PORTAL_BASE = clientViewPartnerPortalBase(AUTOMAP_CLIENT_VIEW_SLUG);

/** Canonical AutoMapa internal admin base path. */
export { AUTOMAP_ADMIN_PORTAL_BASE };

/** @deprecated Use automapAdminPortalPath — kept for legacy redirects and tests. */
export function automapPartnerPortalPath(segment = "") {
  return automapAdminPortalPath(segment);
}
